export default __webpack_public_path__ + "static/media/illustration-work-2-w.4e27a3ac.webp";